import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/CloseModal.svg'


const _hoisted_1 = { class: "reservedLockers" }
const _hoisted_2 = { class: "reservedLockers__body" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = {
  key: 0,
  class: "text"
}
const _hoisted_5 = { class: "reservedLockers__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.showModalReservedLockers)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('closeAllModal')))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.getChoosedLockers(_ctx.choosedLockers)), 1),
                (!_ctx.isAPIReservations)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('kolliID')) + ": " + _toDisplayString(_ctx.deliveryId), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("img", {
                src: _imports_0,
                alt: "CloseModal",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeAllModal')))
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Button, {
                class: "reservedLockers__button",
                variant: "filled",
                title: _ctx.$t('ok'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeAllModal')))
              }, null, 8, ["title"])
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}